import { USER_STATUS, USER_ROLE } from '@/shared/api'

// Константы для пагинации
export const PAGINATION = {
  DEFAULT_LIMIT: 50,
  DEFAULT_PAGE: 1,
} as const

// Маппинг статусов пользователей
export const USER_STATUS_LABELS = {
  [USER_STATUS.ACTIVE]: 'Активен',
  [USER_STATUS.BLOCKED]: 'Заблокирован', 
  [USER_STATUS.DELETED]: 'Удален',
} as const

// Маппинг ролей пользователей
export const USER_ROLE_LABELS = {
  [USER_ROLE.ADMIN]: 'Администратор',
  [USER_ROLE.COURIER]: 'Курьер',
  [USER_ROLE.EXTERNAL_COURIER]: 'Сторонний курьер',
  [USER_ROLE.DEFAULT_USER]: 'Пользователь',
} as const

// Опции для фильтров
export const STATUS_OPTIONS = [
  { value: USER_STATUS.ACTIVE, label: USER_STATUS_LABELS[USER_STATUS.ACTIVE] },
  { value: USER_STATUS.BLOCKED, label: USER_STATUS_LABELS[USER_STATUS.BLOCKED] },
  { value: USER_STATUS.DELETED, label: USER_STATUS_LABELS[USER_STATUS.DELETED] },
]

export const ROLE_OPTIONS = [
  { value: USER_ROLE.ADMIN, label: USER_ROLE_LABELS[USER_ROLE.ADMIN] },
  { value: USER_ROLE.COURIER, label: USER_ROLE_LABELS[USER_ROLE.COURIER] },
  { value: USER_ROLE.EXTERNAL_COURIER, label: USER_ROLE_LABELS[USER_ROLE.EXTERNAL_COURIER] },
  { value: USER_ROLE.DEFAULT_USER, label: USER_ROLE_LABELS[USER_ROLE.DEFAULT_USER] },
]

// Timeout для debounce поиска
export const SEARCH_DEBOUNCE_MS = 500
